<section class="edit-list-connections-dialog">
  <!-- title  -->
  <div class="title">
    <morva-icons icon="close" (click)="closeDialog()"></morva-icons>
    <p>انصراف از بارگذاری منبع‌داده</p>
    <p></p>
  </div>

  <p>
    آیا از لغو بارگذاری منبع‌داده
    "{{ item.dataSourceName }}"
    اطمینان دارید؟
  </p>

  <div class="m-3 px-2 warning-box">
    <morva-icons icon="warning"></morva-icons>
    <p>
      با انصراف از این عملیات، تمام داده‌هایی که تا این لحظه بارگذاری شده‌اند، 
      به طور کامل حذف خواهند شد و کل منبع‌داده پاک می شود.
    </p>
  </div>

  <!-- button group -->
  <div class="button-group">
    <button class="mt-1 delete-shadow" nbButton (click)="closeDialog()">انصراف</button>
    <button class="mt-1 me-0" nbButton (click)="CancelDataSourceUploadProgress()">لغو</button>
  </div>
</section>
